import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { getDailyScheduleHourRange, get_t_str, get_t_str_shortened_max } from "../../../../helpers/helpers";
import { buildScheduledCoverage, localCoverageShifts } from "./scheduledCoverage";

export default function ScheduledCoverageChart({ shifts = [], roleTypes, defaultHours = [], dailyHours = [], height = 56 }) {
  const localShifts = localCoverageShifts(shifts, roleTypes);
  const { start_h, end_h } = getDailyScheduleHourRange(defaultHours, dailyHours, localShifts);
  const data = buildScheduledCoverage(localShifts, undefined, start_h ?? 0, end_h > start_h ? end_h : (start_h ?? 0) + 1);
  const first = data[0].time, last = data[data.length - 1].time;
  return (
    <div role="img" aria-label="Scheduled staffing coverage" className="w-full" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 3, right: 8, bottom: 0, left: 8 }}>
          <XAxis dataKey="time" type="number" domain={[first, last]} ticks={[first, last]} interval={0} tickFormatter={get_t_str_shortened_max} padding={{ left: 8, right: 8 }} tick={{ fontSize: 9 }} axisLine={false} tickLine={false} height={16} />
          <YAxis hide domain={[0, max => Math.max(1, max)]} />
          <Tooltip labelFormatter={get_t_str} formatter={value => [value, "Scheduled"]} />
          <Line type="stepAfter" dataKey="scheduled" name="Scheduled" stroke="#6d28d9" strokeWidth={1.5} dot={false} isAnimationActive={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
